import { render, staticRenderFns } from "./AnnualMarksheet2.vue?vue&type=template&id=70ac86fe&scoped=true&"
import script from "./AnnualMarksheet2.vue?vue&type=script&lang=js&"
export * from "./AnnualMarksheet2.vue?vue&type=script&lang=js&"
import style0 from "./AnnualMarksheet2.vue?vue&type=style&index=0&id=70ac86fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ac86fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VCard,VCol,VContainer,VIcon,VOverlay,VProgressCircular,VRow,VSimpleTable,VSnackbar})
